import React from "react";
import BaseOptions from "./BaseOptions";

/**
 * @class StarRatingFieldOptions
 * @extends BaseOptions
 * @description A component which contains a title, size and required field options
 */
export default class StarRatingFieldOptions extends BaseOptions {
  render() {
    return (
      <div>
        {this.renderTitle()}
        {this.renderRequiredOption()}
        {this.renderVisibilityOption()}
        {this.renderStarRatingSize()}
      </div>
    );
  }
}
